import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from 'src/environments/environment';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private storage: Storage) {}
  set(key: string, value: any): Observable<any> {
    return from(this.storage.set(this._getKey(key), value));
  }
  get(key: string): Observable<any> {
    return from(this.storage.get(this._getKey(key)));
  }
  remove(key: string): Observable<any> {
    return from(this.storage.remove(this._getKey(key)));
  }
  removeAll(): Observable<any> {
    return from(this.storage.clear());
  }
  private _getKey(key: string) {
    return `${environment.name}.${key}`;
  }
}
